<template>
  <c-panel-container :class="[noBorder ? 'no-border' : '']">
    <c-panel-title>
      {{ title }}
    </c-panel-title>
  </c-panel-container>
</template>
<style lang="scss" scoped>
  @import "./index";
</style>
<script>
  export default{
    name: 'c-title-line',
    props: {
      title: {
        type: String,
        default: ''
      },
      noBorder: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {}
    },
    components: {},
    created () {},
    mounted () {},
    beforeDestroy () {},
    methods: {},
    computed: {},
    events: {}
  }
</script>



// WEBPACK FOOTER //
// index.vue?411c6d8e